<template>
  <span>
    <b-button
      variant="outline-primary"
      class="d-flex align-items-center"
      style="height: max-content"
      @click="showModal = true"
    >
      <i class="fa fa-bell mr-1"></i>
      Setting General Reminder
    </b-button>

    <b-modal
      v-model="showModal"
      title="General Setting Reminder"
      hide-footer
      centered
      size="md"
      body-class="p-0"
    >
      <b-form @submit.prevent="handleSubmit">
        <div class="p-3">
          <div
            v-for="(item, index) in forms"
            :key="item.type"
            class="d-flex align-items-center mb-3"
          >
            <b-form-input
              :value="item.type"
              class="mr-3 reminder-type-input"
              readonly
            ></b-form-input>
            <b-input-group class="reminder-value-input">
              <b-form-input
                v-model.number="forms[index][valueField(item)]"
                type="number"
                min="0"
                required
              ></b-form-input>
              <b-input-group-append>
                <b-input-group-text>{{ valueSuffix(item) }}</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>

        <div class="d-flex justify-content-end modal-actions border-top p-3">
          <b-button
            variant="outline-primary"
            class="modal-action-btn mr-2"
            :disabled="loading"
            @click="closeModal"
          >
            Cancel & Close
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            class="modal-action-btn"
            :disabled="loading"
          >
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            Submit
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </span>
</template>

<script>
import { pmsActions } from '@/src/Utils/helper'

export default {
  name: 'SettingGeneralReminderModal',
  data() {
    return {
      showModal: false,
      loading: false,
      forms: this.defaultForms(),
    }
  },
  watch: {
    showModal(val) {
      if (val) {
        this.fetchDefaultForms()
      }
    },
  },
  methods: {
    ...pmsActions,
    defaultForms() {
      return [
        {
          type: 'CALENDAR',
          percentage: null,
          day: 14,
          is_overdue_reminder: 'WEEKLY',
          active: true,
        },
        {
          type: 'COUNTER',
          percentage: 10,
          day: null,
          is_overdue_reminder: 'DAILY',
          active: true,
        },
      ]
    },
    getSettingReminderData(res) {
      const payload = res?.data?.data || res?.data
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.data)) return payload.data
      if (Array.isArray(payload?.setting_reminders)) {
        return payload.setting_reminders
      }
      return []
    },
    mergeDefaultForms(apiForms) {
      return this.defaultForms().map((item) => {
        const apiItem = apiForms.find((form) => form.type === item.type)
        if (!apiItem) return item

        return {
          ...item,
          ...apiItem,
          percentage:
            apiItem.percentage !== null && apiItem.percentage !== undefined
              ? apiItem.percentage
              : item.percentage,
          day:
            apiItem.day !== null && apiItem.day !== undefined
              ? apiItem.day
              : item.day,
          is_overdue_reminder:
            apiItem.is_overdue_reminder || item.is_overdue_reminder,
          active:
            apiItem.active !== null && apiItem.active !== undefined
              ? apiItem.active
              : item.active,
        }
      })
    },
    async fetchDefaultForms() {
      try {
        this.loading = true
        this.forms = this.defaultForms()

        const res = await this.getPmsSettingReminders()
        if (res.status !== 'success') return

        const apiForms = this.getSettingReminderData(res)
        if (apiForms.length) {
          this.forms = this.mergeDefaultForms(apiForms)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    valueField(item) {
      return item.type === 'CALENDAR' ? 'day' : 'percentage'
    },
    valueSuffix(item) {
      return item.type === 'CALENDAR' ? 'Day' : '%'
    },
    buildPayload() {
      return this.forms.map((item) => ({
        type: item.type,
        percentage:
          item.type === 'COUNTER' ? Number(item.percentage || 0) : null,
        day: item.type === 'CALENDAR' ? Number(item.day || 0) : null,
        is_overdue_reminder: item.is_overdue_reminder,
        active: item.active,
      }))
    },
    closeModal() {
      this.showModal = false
      this.forms = this.defaultForms()
    },
    async handleSubmit() {
      try {
        this.loading = true
        const res = await this.createPmsSettingReminders(this.buildPayload())
        if (res.status === 'success') {
          this.$swal(
            'Success',
            'General reminder setting has been saved.',
            'success'
          )
          this.closeModal()
          this.$emit('refetch')
        } else {
          this.$swal(
            'Error',
            'Failed to save general reminder setting.',
            'error'
          )
        }
      } catch (error) {
        console.log(error)
        this.$swal('Error', 'Failed to save general reminder setting.', 'error')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.reminder-type-input {
  width: 100%;
}
.reminder-value-input {
  width: 100%;
}
.modal-actions {
  margin-top: 72px;
}
.modal-action-btn {
  min-width: 128px;
}
</style>
